import {LabelToken as SharedLabelToken, type LabelTokenProps as SharedLabelTokenProps} from '@github-ui/label-token'
import {
  isLabelArchived,
  labelAccessibleName as sharedLabelAccessibleName,
} from '@github-ui/label-token/RepositoryLabelToken'

import type {Label} from '../../api/common-contracts'
import {SanitizedHtml} from '../dom/sanitized-html'
import styles from './label-token.module.css'

interface LabelTokenProps extends Omit<SharedLabelTokenProps, 'text' | 'fillColor' | 'isArchived' | 'label' | 'ref'> {
  label: Label
  ref?: React.Ref<HTMLAnchorElement>
}

export const labelAccessibleName = (label: Label) => sharedLabelAccessibleName(label)

export const LabelToken = ({ref, label, ...tokenProps}: LabelTokenProps) => {
  return (
    <SharedLabelToken
      text={<SanitizedHtml>{label.nameHtml}</SanitizedHtml>}
      fillColor={`#${label.color}`}
      isArchived={isLabelArchived(label)}
      ref={ref}
      {...tokenProps}
    />
  )
}
LabelToken.displayName = 'LabelToken'

export const LabelDecorator = ({color}: {color: string}) => {
  return (
    <div
      className={styles.LabelTokenDecorator}
      style={{
        backgroundColor: `#${color}`,
        borderColor: `#${color}`,
      }}
    />
  )
}
